import { ApplicationConfig, importProvidersFrom, isDevMode, LOCALE_ID } from '@angular/core';
import { provideRouter, withHashLocation } from '@angular/router';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { routes } from './app.routes';
import { BarcodeScannerLivestreamModule } from 'ngx-barcode-scanner';
import { provideServiceWorker } from '@angular/service-worker';
import { SioService } from './service/sio/sio.service';
import { GANTT_GLOBAL_CONFIG } from '@worktile/gantt';
// import { provideSocketIo, SocketIoConfig } from 'ngx-socket-io';
import { environment } from '../environments/environment';


// const config: SocketIoConfig = { url: environment.sio_base_url, options: {} };

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withHashLocation()),
    provideHttpClient(withFetch()),
    SioService,
    importProvidersFrom(BrowserModule, BrowserAnimationsModule, BarcodeScannerLivestreamModule),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    }),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    }),
    {
      provide: GANTT_GLOBAL_CONFIG,
      useValue: {
        dateFormat: {
          yearQuarter: `QQQ 'of' yyyy`,
          month: 'LLLL',
          yearMonth: `LLLL yyyy'(week' w ')'`
        },
        today: 'Aujourd\'hui',
        months: [
          'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
          'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'
        ],
        weekdays: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
        locale: 'fr', // Forcer la langue en français
        // Suppression des textes chinois en redéfinissant toutes les clés
        addTask: 'Ajouter une tâche',
        deleteTask: 'Supprimer la tâche',
        startDate: 'Date de début',
        endDate: 'Date de fin',
        duration: 'Durée',
        progress: 'Avancement',
        dependencies: 'Dépendances',
        resources: 'Ressources',
        settings: 'Paramètres',
        save: 'Enregistrer',
        cancel: 'Annuler'
      }
    },
    { provide: LOCALE_ID, useValue: 'fr' },
    // provideSocketIo(config)
  ]
};